import {
  arrayOf,
  bool,
  func,
  number,
  object,
  oneOfType,
  shape,
  string,
} from 'prop-types'
import {
  FormControl as MUIFormControl,
  InputLabel as MUIInputLabel,
  MenuItem as MUIMenuItem,
  Select as MUISelect,
} from '@mui/material'
import { SHARED_STYLES } from './consts'
import { toKebabCaseLowerCase } from 'utilities/string'

const STYLES = {
  disabled: {
    '& .MuiInputBase-input.Mui-disabled': SHARED_STYLES.disabledInputBox,
    ...SHARED_STYLES.disabledInput,
  },
  dropdownOptions: SHARED_STYLES.dropdownOptions,
  menuItem: {
    '&.MuiMenuItem-root': {
      display: 'block',
      paddingLeft: '16px',
    },
  },
  readOnly: SHARED_STYLES.readOnlyInput,
}

const Select = ({
  disabled,
  label,
  name,
  onChange,
  options,
  readOnly,
  showLabel = true,
  sxSelect,
  value,
  variant = 'outlined',
  ...props
}) => {
  // Convert label to lowercase and replace spaces with hyphens
  const reformattedLabel = toKebabCaseLowerCase(label)
  const labelId = `${reformattedLabel}-label`
  const selectId = `${reformattedLabel}-select`

  const handleChange = (event) => {
    onChange({
      target: {
        name,
        value: event.target.value,
      },
    })
  }

  return (
    <MUIFormControl
      fullWidth
      {...{
        disabled,
        sx: {
          ...(readOnly && STYLES.readOnly),
          ...(disabled && !readOnly && STYLES.disabled),
        },
      }}
    >
      {showLabel && <MUIInputLabel id={labelId}>{label}</MUIInputLabel>}
      <MUISelect
        {...{
          id: selectId,
          label,
          labelId,
          onChange: handleChange,
          sx: sxSelect,
          value,
          variant,
          MenuProps: {
            MenuListProps: {
              sx: STYLES.dropdownOptions,
            },
          },
          ...props,
        }}
      >
        {options.map((option) => {
          if (typeof option === 'string') {
            return (
              <MUIMenuItem
                disabled={false}
                key={option}
                value={option}
                sx={STYLES.menuItem}
              >
                {option}
              </MUIMenuItem>
            )
          }

          const { disabled, key, name, value, ...props } = option
          return (
            <MUIMenuItem
              {...{ key, disabled, name, ...props, value, sx: STYLES.menuItem }}
            >
              {name}
            </MUIMenuItem>
          )
        })}
      </MUISelect>
    </MUIFormControl>
  )
}

export default Select

Select.propTypes = {
  disabled: bool,
  label: string.isRequired,
  name: string,
  onChange: func,
  options: arrayOf(
    oneOfType([
      shape({
        disabled: bool,
        key: string,
        name: string.isRequired,
        value: oneOfType([number, string]).isRequired,
      }),
      string,
    ]),
  ),
  readOnly: bool,
  sxSelect: object,
  value: oneOfType([number, string]),
}
